import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../services/api";
import Sidebar from "../../components/sidebar/Sidebar";

import {
  PageLayout,
  Container,
  Header,
  Title,
  Subtitle,
  SearchInput,
  AddButton,
  SearchWrapper,
  SortWrapper,

  AchievementsGrid,
  AchievementCard,
  AchievementHeader,
  AchievementIcon,
  AchievementIconWrapper,
  AchievementActions,
  AchievementTitle,
  AchievementDescription,
  AchievementTag,
  StatusBadge,

  ModalContent,
  ModalOverlay,
  ModalImageHeader,
  ModalSection,
  ModalTag,
  ModalCloseButton
} from "./styles";

import {
  Eye,
  Edit,
  Trash2,
  Plus,
  Search,
  X,
  Trophy
} from "lucide-react";


/* 🔹 Helper imagem */
const getImagemUrl = (imagem) => {
  if (!imagem) return "https://placehold.co/600x200?text=Sem+Imagem";
  if (imagem.startsWith("http")) return imagem;

  const baseURL = api.defaults.baseURL;
  return `${baseURL}/${imagem.replace(/^\/?/, "")}`;
};


const Conquistas = () => {
  const navigate = useNavigate();

  const [conquistas, setConquistas] = useState([]);
  const [query, setQuery] = useState("");
  const [sortType, setSortType] = useState("az");
  const [loading, setLoading] = useState(true);

  const [showModal, setShowModal] = useState(false);
  const [conquistaSelecionada, setConquistaSelecionada] = useState(null);

  // 🔹 Buscar conquistas
  useEffect(() => {
    const fetchConquistas = async () => {
      try {
        const response = await api.get("/api/achievements");
        setConquistas(Array.isArray(response.data) ? response.data : []);
      } catch (error) {
        console.error("Erro ao buscar conquistas:", error);
        setConquistas([]);
      } finally {
        setLoading(false);
      }
    };
    fetchConquistas();
  }, []);

  // 🔹 Deletar conquista
  const handleDelete = async (id) => {
    if (!window.confirm("Deseja excluir esta conquista?")) return;

    try {
      await api.delete(`/api/achievements/${id}`);
      setConquistas((prev) => prev.filter((c) => c._id !== id));
    } catch (error) {
      alert("Erro ao deletar conquista.");
    }
  };

  // 🔹 Filtro
  const filtered = conquistas.filter(
    (c) =>
      c.titulo?.toLowerCase().includes(query.toLowerCase()) ||
      c.descricao?.toLowerCase().includes(query.toLowerCase())
  );

  // 🔹 Ordenação
  const sortConquistas = (list) => {
    const copy = [...list];
    if (sortType === "az") copy.sort((a, b) => a.titulo.localeCompare(b.titulo));
    if (sortType === "za") copy.sort((a, b) => b.titulo.localeCompare(a.titulo));
    if (sortType === "xp") copy.sort((a, b) => b.xp - a.xp);
    return copy;
  };

  const displayed = sortConquistas(filtered);

  return (
    <PageLayout>
      <Sidebar />

      <Container>
        <Header>
          <div>
            <Title>Gerenciar conquistas</Title>
            <Subtitle>Crie e gerencie conquistas da plataforma</Subtitle>
          </div>

          <AddButton onClick={() => navigate("/criar-conquista")}>
            <Plus size={18} />
            Nova conquista
          </AddButton>
        </Header>

        <SortWrapper>
          <label>Ordenar por:</label>
          <select value={sortType} onChange={(e) => setSortType(e.target.value)}>
            <option value="az">A–Z</option>
            <option value="za">Z–A</option>
            <option value="xp">XP</option>
          </select>
        </SortWrapper>

        <SearchWrapper>
          <Search size={18} />
          <SearchInput
            placeholder="Pesquisar conquistas..."
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
        </SearchWrapper>

        {loading ? (
          <p style={{ padding: 40, textAlign: "center" }}>
            Carregando conquistas...
          </p>
        ) : displayed.length === 0 ? (
          <p style={{ padding: 40, textAlign: "center" }}>
            Nenhuma conquista encontrada.
          </p>
        ) : (
          <AchievementsGrid>
            {displayed.map((conquista) => (
              <AchievementCard key={conquista._id}>
                

                <AchievementHeader>
  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
    <AchievementIconWrapper>
      <AchievementIcon />
    </AchievementIconWrapper>

    <StatusBadge>
      {conquista.ativa ? "Ativa" : "Inativa"}
    </StatusBadge>
  </div>

  <AchievementActions>
    <Eye
      size={18}
      onClick={() => {
        setConquistaSelecionada(conquista);
        setShowModal(true);
      }}
    />
    <Edit
      size={18}
      onClick={() =>
        navigate(`/editar-conquistas/${conquista._id}`)
      }
    />
    <Trash2
      size={18}
      color="#EF4444"
      onClick={() => handleDelete(conquista._id)}
    />
  </AchievementActions>
</AchievementHeader>


                <AchievementTitle>{conquista.titulo}</AchievementTitle>
                <AchievementDescription>
                  {conquista.descricao}
                </AchievementDescription>

                <ModalSection>
                  <strong>{conquista.xp} XP</strong>
                </ModalSection>

                

                {conquista.tags?.length > 0 && (
                  <div style={{ marginTop: 10, display: "flex", gap: 6, flexWrap: "wrap" }}>
                    {conquista.tags.map((tag, i) => (
                      <AchievementTag key={i}>#{tag}</AchievementTag>
                    ))}
                  </div>
                )}
              </AchievementCard>
            ))}
          </AchievementsGrid>
        )}
      </Container>

      {/* 🔥 MODAL VISUALIZAÇÃO */}
      {showModal && conquistaSelecionada && (
        <ModalOverlay onClick={() => setShowModal(false)}>
          <ModalContent onClick={(e) => e.stopPropagation()}>
            <ModalCloseButton onClick={() => setShowModal(false)}>
              <X size={18} />
            </ModalCloseButton>

            <ModalImageHeader>
              <img
                src={getImagemUrl(conquistaSelecionada.imagem)}
                alt={conquistaSelecionada.titulo}
              />
            </ModalImageHeader>

            <div style={{ padding: "1.5rem" }}>
              <h2>{conquistaSelecionada.titulo}</h2>
              <p>{conquistaSelecionada.descricao}</p>

              <ModalSection>
                <strong>XP:</strong> {conquistaSelecionada.xp}
              </ModalSection>

              <ModalSection>
                <strong>Status:</strong>{" "}
                {conquistaSelecionada.ativa ? "Ativa" : "Inativa"}
              </ModalSection>

              <ModalSection>
                <strong>Critério de desbloqueio</strong>
                <p>
                  {conquistaSelecionada.criterioDesbloqueio?.acao}{" "}
                  {conquistaSelecionada.criterioDesbloqueio?.quantidade}{" "}
                  {conquistaSelecionada.criterioDesbloqueio?.tipo}
                </p>
              </ModalSection>

              <ModalSection>
                <strong>Tags</strong>
                {conquistaSelecionada.tags?.length ? (
                  <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                    {conquistaSelecionada.tags.map((tag, i) => (
                      <ModalTag key={i}>#{tag}</ModalTag>
                    ))}
                  </div>
                ) : (
                  <p>Sem tags</p>
                )}
              </ModalSection>
            </div>
          </ModalContent>
        </ModalOverlay>
      )}
    </PageLayout>
  );
};

export default Conquistas;
